import { useProducts } from "@/hooks/useProducts";
import ProductCard from "./ProductCard";
import { Trophy } from "lucide-react";
import ScrollReveal from "@/components/3d/ScrollReveal";

const TopSellers = () => {
  const { data: products = [], isLoading } = useProducts();
  const topSellers = [...products].sort((a, b) => b.reviews - a.reviews).slice(0, 8);

  return (
    <section className="py-10">
      <div className="container mx-auto px-4">
        <ScrollReveal direction="up">
          <div className="flex items-center gap-3 mb-6">
            <Trophy className="h-5 w-5 text-primary" />
            <h2 className="font-display text-2xl font-black">Top Sellers</h2>
          </div>
        </ScrollReveal>
        <div className="grid gap-4 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4">
          {isLoading
            ? Array.from({ length: 8 }).map((_, i) => (
                <div key={i} className="animate-pulse rounded-lg border border-border/50 bg-card">
                  <div className="aspect-square bg-secondary" />
                  <div className="p-3 space-y-2">
                    <div className="h-3 w-2/3 rounded bg-secondary" />
                    <div className="h-3 w-1/3 rounded bg-secondary" />
                  </div>
                </div>
              ))
            : topSellers.map((p, i) => (
                <ScrollReveal key={p.id} direction="up" delay={i * 0.05}>
                  <ProductCard product={p} index={0} rank={i + 1} />
                </ScrollReveal>
              ))}
        </div>
      </div>
    </section>
  );
};

export default TopSellers;
